import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import tgcDynamicForms from "@tgl/tgc-dynamic-forms";

Vue.use(tgcDynamicForms);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(tgcDynamicForms);
